// src/features/wallet/components/WalletWorkspaceHeader.tsx
import { PageHeader, formatPersianNumber } from '../../../app/components/foundation';
import type { Wallet } from '../types/wallet.types';
import { WalletStatusBadge } from './WalletStatusBadge';

export interface WalletWorkspaceHeaderProps {
  wallet: Wallet;
}

/**
 * Top-of-page header for the wallet workspace. Same choice
 * commission/components/CommissionWorkspaceHeader.tsx and
 * orders/components/OrderWorkspaceHeader.tsx make: reuses the shared
 * PageHeader primitive directly instead of a custom Card layout —
 * wallet number as the title, id as supporting description, and the
 * status badge in the actions slot (rendered inline with the title,
 * same as every other feature's PageHeader usage).
 */
export function WalletWorkspaceHeader({ wallet }: WalletWorkspaceHeaderProps) {
  return (
    <PageHeader
      title={`کیف پول کاربر ${formatPersianNumber(wallet.id)}`}
      description={`شناسه تلگرام: ${formatPersianNumber(wallet.telegram_id)}`}
      actions={<WalletStatusBadge status={wallet.status} />}
    />
  );
}
